import {
  Header,
  Hero,
  Section,
  Sponsors,
  MasonryList,
  Divider,
} from '@components';

import { DefaultLayout } from '@layouts';
import { NextSeo } from 'next-seo';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { stringify } from 'qs';

export default function EventPage({ data }) {
  const { hero, seo, sponsors, gallery, banner } = data;

  return (
    <>
      <NextSeo
        title={`Momento | ${seo?.metaTitle}`}
        description={seo?.metaDescription}
      />
      <DefaultLayout
        header={
          <Hero
            isHero
            cta={hero?.cta}
            label={hero?.label}
            title={hero?.title}
            description={hero?.description}
            hasSlider={hero?.media?.data?.length > 0}
            slides={hero?.media?.data.map(({ attributes }) => {
              return {
                img: attributes,
              };
            })}
          />
        }
      >
        {sponsors?.length > 8 && <Sponsors sponsors={sponsors} />}

        <Section>
          <Header
            title={gallery?.title}
            label={gallery?.label}
            description={gallery?.description}
          />
          <MasonryList gallery={gallery?.media?.data} pagination />
        </Section>

        <Divider {...banner} />
        <div className="h-20"></div>
      </DefaultLayout>
    </>
  );
}

export async function getServerSideProps({ locale }) {
  /*   res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59',
  ); */

  try {
    const path = process.env.NEXT_PUBLIC_STRAPI; // process.env.NEXT_PUBLIC_STRAPI;
    const lang = `locale=${locale}`;

    const populateEventPage = stringify(
      {
        populate: [
          'hero',
          'hero.media',
          'seo',
          'sponsors.list',
          'sponsors.img',
          'gallery',
          'gallery.media',
          'banner',
          'banner.img',
        ],
      },
      { encodeValuesOnly: true },
    );

    // HomePage Data
    const getEventPage = await fetch(
      `${path}/events-page?populate=${populateEventPage}&${lang}`,
    );
    const eventPage = await getEventPage?.json();

    return {
      props: {
        ...(await serverSideTranslations(locale, ['common'])),
        data: eventPage?.data?.attributes || {},
      },
    };
  } catch (error) {
    console.error('SSR error:', error);
    return { notFound: true };
  }
}
